import React from 'react';
import { brand, footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-white py-14 md:py-16" data-id="element-51" data-mp="3gfsnkey6wyo1">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-52" data-mp="3ghc3u5juj9pt">
        <p className="text-xl font-extrabold tracking-tight text-slate-900 md:text-2xl" data-id="element-53" data-mp="32p5lcct80qn7">{brand.name}</p>

        <nav aria-label="Enlaces del sitio" data-id="element-54" data-mp="36pzatambadi7">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-semibold text-slate-500" data-id="element-55" data-mp="3uf0md6qfy4rp">
            {footerLinks.map(link => <li key={link.label} data-id="element-56" data-mp="37xwcimca4j2">
                <a href={link.href} className="rounded transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-57" data-mp="3lem127dh8po7">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 text-sm text-slate-500" data-id="element-58" data-mp="2evxat0b6nh1u">
          © 2026 {brand.name}. Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-slate-500" data-id="element-59" data-mp="3gaz3l7v1stm7">
          Material educativo y de consulta visual dirigido a estudiantes y profesionales. No sustituye
          la valoración clínica individual, la prescripción, la formación profesional, las
          instrucciones del fabricante, las fuentes actualizadas de compatibilidad ni los protocolos
          institucionales.
        </p>
      </div>
    </footer>;
}